import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { IRFQTemplateDetail } from '../../models';
import { EncryptionService } from 'src/app/modules/dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class RfqService {

  constructor(private http: HttpClient, private _encryptionService: EncryptionService) { }

  public createRFQ(rfq: any, files: any, rfqType:any) : Observable<IAPIResponse<any>> {
    let formData = new FormData();
    rfq.forEach((rfq:any)=>{
      rfq.rfq_type = rfqType;
    })
    formData.append('rfqData',JSON.stringify(rfq));
    if(files?.length){
      files.forEach((file:any)=>{
        formData.append('files',file.file);
      })
    }
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.RFQ.CREATE}`, formData);
  }

  public updateRFQ(rfq: any) : Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.RFQ.UPDATE}`, rfq);
  }

  public fetchRFQSummaryList() : Observable<IAPIResponse<Array<any>>> {
    return this.http.get<IAPIResponse<Array<any>>>(`${API_URL.BUYER.RFQ.FETCH_RFQ_SUMMARY_LIST}`);
  }

  public fetchRFQDetail(status : string = "") : Observable<IAPIResponse<Array<IRFQTemplateDetail>>> {
    return this.http.get<IAPIResponse<Array<IRFQTemplateDetail>>>(`${API_URL.BUYER.RFQ.FETCH_RFQ_DETAILS}&status=${this._encryptionService.encryptPayload(encodeURIComponent(status))}`);
  }

  public fetchPR_RFQDetail(prId : string = "") : Observable<IAPIResponse<Array<IRFQTemplateDetail>>> {
    return this.http.get<IAPIResponse<Array<IRFQTemplateDetail>>>(`${API_URL.BUYER.RFQ.FETCH_RFQ_PRID}?prId=${prId}`);
  }

  public deleteSupplierFromRFQ(supplierMetadata : any) : Observable<IAPIResponse<any>> {
    return this.http.put<IAPIResponse<any>>(`${API_URL.BUYER.RFQ.DELETE_SUPPLIER_FROM_RFQ}`, supplierMetadata);
  }

  // general API endpoint
  public fetchData(URL : string) : Observable<any> {
    return this.http.get<any>(`${URL}`);
  }

  // rfq template upload APIs
  uploadRFQTemplateAttachment(body : FormData, RfqID : any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.UPLOAD_ATTACHMENT}?rfqId=${this._encryptionService.encryptPayload(RfqID)}`, body);
  }

  deletedRFQTemplateAttachment(id : number) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.DELETE_ATTACHMENT}?id=${this._encryptionService.encryptPayload(id)}`, {});
  }

  deletedRFQTemplate(data : {rfq_template_id : any}) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.DELETE_RFQ}`, data);
  }

  downloadRFQTemplateAttachment(id : number) : any {
    return this.http.get<any>(`${API_URL.BUYER.RFQ.DOWNLOAD_ATTACHMENT}?id=${id}`, {
      responseType: 'blob' as any,
    });
  }

  fetchRFQTemplateAttachments(id ?: number,supplierCode?:any) : Observable<any> {
    if(!id) return this.http.get<any>(`${API_URL.BUYER.RFQ.FETCH_ATTACHMENT}`);
    return this.http.get<any>(`${API_URL.BUYER.RFQ.FETCH_ATTACHMENT}?rfqId=${this._encryptionService.encryptPayload(id)}&supplierCode=${this._encryptionService.encryptPayload(supplierCode)}`);
  }

  public fetchRFQVendorData(body : any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.FETCH_VENDOR_DATA}`, body);
  }

  public addRFQVendorDataForExisting(rfq : any,files?:any) : Observable<any> {
    let formData = new FormData();
    formData.append('rfqData',JSON.stringify(rfq));
    if(files?.length){
      files.forEach((file:any)=>{
        formData.append('files',file.file);
      })
    }
    return this.http.post<any>(`${API_URL.BUYER.RFQ.ADD_VENDOR}`, formData);
  }

  public addRFQUnRegisteredVendorDataForExisting(rfq : any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.RFQ.ADD_UNREGISTERED_VENDOR}`, rfq);
  }

  public getMaterialDetails(material_code:any,plant:any) : Observable<any> { //getHSN value
    return this.http.get<any>(`${API_URL.FETCH_MATERIAL_DETAILS}?material_code=${this._encryptionService.encryptPayload(encodeURIComponent(material_code))}&plant=${this._encryptionService.encryptPayload(encodeURIComponent(plant))}`);
  }

  public getTaxTariffCode(code:any) : Observable<any> { //getSAC tariff value
    return this.http.get<any>(`${API_URL.FETCH_TAC_TARIFF_CODE}${code}`);
  }
  
  public getMaterialDataForLineItem(prId: any,lineitem_list: any) : Observable<any> { 
    return this.http.post<any>(`${API_URL.GET_LINEITEM_MATERIAL_DATA}`,{ "prId":prId, "line_item_no":lineitem_list});
  }

  public getPaymentTermsByCode(code:any):Observable<any>{
    return this.http.get(`${API_URL.GET_PYAMENTTERMS_DESC}code=${code}`)
  } 

  public updateRFQSelectedVendor(payload: any) : Observable<any> { 
    return this.http.post<any>(`${API_URL.RFQ_SELECTED_VENDOR}`,payload);
  }

  public getRFQSelectedVendor(payload: any) : Observable<any> { 
    return this.http.get<any>(`${API_URL.RFQ_SELECTED_VENDOR}?prId=${payload.prId}`);
  }

  public updateQuotationDeadlines(payload: any) : Observable<any> { 
    return this.http.post<any>(`${API_URL.UPDATE_QUOTATION_DEADLINES}`,payload);
  }

  public updateRFQRemarks(payload: any) : Observable<any> { 
    return this.http.post<any>(`${API_URL.UPDATE_RFQ_REMARKS}`,payload);
  }
  
  public getNegotiationsBySupplier() : Observable<any> { 
    return this.http.get<any>(`${API_URL.SUPPLIER.RFQ.GET_NEGOTIATION_DETAILS_BY_SUPPLIER}`);
  }
}
